// src/pages/FlightTracker.js
import React, { useState } from "react";
import "./FlightTracker.css";

function FlightTracker() {
  const [formData, setFormData] = useState({
    name: "",
    policyNumber: "",
    contactNumber: "",
    docType: "Project Photos / Videos",
    file: null,
  });

  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("policyNumber", formData.policyNumber);
      formDataToSend.append("contactNumber", formData.contactNumber);
      formDataToSend.append("docType", formData.docType);

      if (formData.file) {
        formDataToSend.append("file", formData.file);
      }

      const response = await fetch("php/mail.php", {
        method: "POST",
        body: formDataToSend,
      });

      const resultText = await response.text();

      if (resultText && resultText.toLowerCase().includes("success")) {
        setShowPopup(true);
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 6000);
      } else {
        alert("There was an error submitting your upload. Please try again.");
      }
    } catch (error) {
      alert("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <div className="upload-page">
      <div className="upload-card">
        <img
          src="/seal.png"
          alt="Greenview San Diego Hardscape Seal"
          className="seal"
        />

        <h1 className="upload-title">
          Secure Project Document Upload
          <br />
          <span>
            Greenview San Diego Hardscape — Licensed C-27 Landscape Contractor
            (CSLB #1141945)
          </span>
        </h1>

        <form onSubmit={handleSubmit} className="upload-form">
          <label>Name (Homeowner / Contractor / Staff)</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your full name"
            required
          />

          <label>Job / Contract / Change Order #</label>
          <input
            type="text"
            name="policyNumber"
            value={formData.policyNumber}
            onChange={handleChange}
            placeholder="Enter job number, contract number, or reference ID"
            required
          />

          <label>Best Contact Number</label>
          <input
            type="text"
            name="contactNumber"
            value={formData.contactNumber}
            onChange={handleChange}
            placeholder="Phone or WhatsApp number"
            required
          />

          <label>Type of Upload</label>
          <select
            name="docType"
            value={formData.docType}
            onChange={handleChange}
          >
            <option>Project Photos / Videos</option>
            <option>Plans / Diagrams</option>
            <option>Change Order Documentation</option>
            <option>Signed Contract / Agreement</option>
            <option>Permit / Inspection Document</option>
            <option>Invoice / Payment Proof</option>
            <option>Other Project Document</option>
          </select>

          <label>
            Upload File (Photos, Videos, PDFs, Plans, or Documents)
          </label>
          <input
            type="file"
            name="file"
            accept=".mp4,.mp3,.png,.jpeg,.jpg,.pdf,.heic"
            onChange={handleChange}
            required
          />

          <button type="submit" className="submit-btn">
            Submit Project Upload
          </button>
        </form>

        <footer className="upload-footer">
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>{" "}
          |{" "}
          <a href="/terms" target="_blank" rel="noopener noreferrer">
            Terms & Conditions
          </a>
        </footer>
      </div>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <h2>✅ Upload Successfully Submitted</h2>
            <p>
              Your project documents were securely uploaded to{" "}
              <strong>Greenview San Diego Hardscape</strong>. Our team will
              review your files and associate them with your project record.
              You will now be redirected to the main portal.
            </p>
            <button onClick={() => setShowPopup(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default FlightTracker;